class PassEvent {
	constructor({in: input, out: output}) {
		this.in = input;
		this.out = output;
	}
}

module.exports = PassEvent;
